module.exports = __webpack_public_path__ + "img/pt-24.477743f3.jpg";